export default "__VITE_ASSET__BlO6XZom__"